import { Helmet } from "react-helmet-async";

import ExchangeTable from "../components/ExchangeTable";
import FeeInfo from "../components/FeeInfo";
import InfoSections from "../components/InfoSections";

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>
          Lo-Fee.com - Compare Canadian Bitcoin Exchange Fees & Rates
        </title>
        <meta
          name="description"
          content="Find the lowest Bitcoin exchange fees in Canada. Compare rates, payment methods, and trading fees across major Canadian cryptocurrency exchanges."
        />
        <link rel="canonical" href="https://lo-fee.com/" />
      </Helmet>
      <div className="border-b border-gray-200 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 py-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <h1 className="text-2xl font-bold">
              Compare Canadian Bitcoin Exchange Fees
            </h1>
          </div>
        </div>
      </div>
      <main className="w-full max-w-[1400px] mx-auto px-2 sm:px-4 py-4 sm:py-6 flex-1">
        <ExchangeTable />
        <FeeInfo />
        <InfoSections />
      </main>
    </>
  );
};

export default Homepage;
